
import EmpolyeeList from './index.vue'

EmpolyeeList.install = function (Vue) {
  Vue.component(EmpolyeeList.name, EmpolyeeList)
}

export default EmpolyeeList